import React from 'react';
import { useTranslate } from 'react-admin';
import { formatCityId } from '../../utils/cityDisplay';
import DynamicCell from './DynamicCell';

/**
 * Event listesinde sehir: event.city = venue'den kopyalanan cities slug.
 */
const EventCityCell = ({ row }) => {
  const translate = useTranslate();
  const cityId = row?.city;

  if (cityId) {
    return <span>{formatCityId(cityId, translate)}</span>;
  }

  if (row?.venue) {
    return (
      <DynamicCell
        reference="venues"
        id={row.venue}
        renderFunction={(venue) => formatCityId(venue?.city, translate)}
      />
    );
  }

  return <span>N/A</span>;
};

export default EventCityCell;
